import { LocalStorageKey } from '@/hooks/storage/useLocalStorage';
import { BetPayload } from '@/models/games/BetRoom';
import { betAnalyticThunk } from '@/modules/analytic/thunk';
import {
    betRoomSliceActions,
    getBetRoom,
    getPlayerSeatNo,
} from '@/modules/bet/room/slice';
import {
    getTableBetByGameId,
    tableBetSliceActions,
} from '@/modules/betTable/slice';
import {
    getHostLiveDataByHostId,
    hostLiveSliceActions,
} from '@/modules/hostLive/slice';
import { getMainUserState } from '@/modules/main/selector';
import { LiveDataSliceActions } from '@/modules/main/slice/liveData';
import { Dispatch } from '@reduxjs/toolkit';
import moment from 'moment';
import { batch } from 'react-redux';
import { getHostByGameId } from '../../../modules/host/slice';
import { inGamePopupSliceActions } from '../../../modules/popup/inGameSlice';
import store from '../../../store/store';
import { StateMsgType } from '../../Popup';
import { GameError } from '../../games/enums/GameError';
import { GameType as GameTypeEnum } from '../../games/enums/GameType';
import { Bet } from '../../host/BetAmount';
import { CMDSpBetResult, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';
export class CMDSpBetResultHandler extends AbstractHandler {
    _command: CMDSpBetResult;
    _specialMsg: string;
    _isMessageExist: (key: string) => boolean;

    constructor(
        command: ICommand,
        specialMsg: string,
        isMessageExist: (key: string) => boolean
    ) {
        super();
        this._command = command as CMDSpBetResult;
        this._specialMsg = specialMsg;
        this._isMessageExist = isMessageExist;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    override handle(dispatch: Dispatch<any>): void {
        const state = store.getState();
        // if (gameState.currentGameId != this._command.GameID) return;

        const { ConfirmedBets } = getTableBetByGameId(
            state,
            this._command.GameID
        );
        const host = getHostByGameId(state, this._command.GameID);
        if (!host) return;
        const { GameType, HostId } = host;
        const { PendingTime, RemainTime } = getHostLiveDataByHostId(
            state,
            HostId
        );
        const { Username } = getMainUserState(state);
        dispatch(
            tableBetSliceActions.setWaitingBetResult({
                hostId: HostId,
                gameId: this._command.GameID,
                value: false,
            })
        );

        console.log(`hook::socket::run::${HostId}`, this._command);
        if (this._command.Reason === this.SUCCESS_CODE) {
            const hostIds = localStorage.getItem(
                LocalStorageKey.RecentlyPlayed + Username
            );
            if (hostIds && hostIds.length > 0) {
                let recentlyList = JSON.parse(hostIds)['hostIds'];
                let recently = recentlyList.filter(
                    (h: { hostId: number }) => h.hostId != HostId
                );
                const newRecently = [{ hostId: HostId }]
                    .concat(recently)
                    .slice(0, 8);
                localStorage.setItem(
                    LocalStorageKey.RecentlyPlayed + Username,
                    JSON.stringify({ hostIds: newRecently })
                );
            } else {
                localStorage.setItem(
                    LocalStorageKey.RecentlyPlayed + Username,
                    JSON.stringify({ hostIds: [{ hostId: HostId }] })
                );
            }

            localStorage.setItem(
                LocalStorageKey.LastBetTs,
                Date.now().toString()
            );

            let Bets = this._command.Bet.map(
                b =>
                    ({
                        Type: b.Base.betType,
                        Amount: ConfirmedBets[b.Base.betType]
                            ? ConfirmedBets[b.Base.betType] + b.Base.betAmount
                            : b.Base.betAmount,
                        GameId: this._command.GameID,
                    }) as Bet
            );

            let newConfirmedBets = [...ConfirmedBets];
            Bets.forEach(bet => {
                newConfirmedBets[bet.Type] = bet.Amount;
            });

            batch(() => {
                if (PendingTime) {
                    const curTimer = Math.max(
                        0,
                        Math.round((RemainTime - moment().valueOf()) / 1000)
                    );
                    const time = PendingTime + curTimer * 1000;
                    dispatch(
                        hostLiveSliceActions.updateCountDown({
                            hostId: HostId,
                            countDown: time,
                            canLeave: false,
                        })
                    );
                }
                dispatch(
                    tableBetSliceActions.clearPendingBets({
                        hostId: HostId,
                        gameId: this._command.GameID,
                        startGame: false,
                    })
                );
                if (host.GameType === GameTypeEnum.Baccarat) {
                    dispatch(
                        LiveDataSliceActions.updateBaccaratBetHistory({
                            hostId: host.HostId,
                            gameId: this._command.GameID,
                            betsSummary: newConfirmedBets,
                        })
                    );
                }
                dispatch(
                    tableBetSliceActions.updateConfirmedBets({
                        hostId: HostId,
                        gameId: this._command.GameID,
                        bets: newConfirmedBets,
                    })
                );
                dispatch(
                    betAnalyticThunk({
                        command: this._command,
                        isNbs: false,
                    })
                );
                // dispatch(
                //     hostsSliceActions.updateConfirmedBets({
                //         hostId: HostId,
                //         gameId: this._command.GameID,
                //         bets: Bet,
                //     })
                // );
                // dispatch(
                //     gameSliceActions.onConfirmedBetResult({
                //         gameId: this._command.GameID,
                //         bet: Bet,
                //     })
                // );
                if (GameType == GameTypeEnum.Blackjack) {
                    //For User bet behind information
                    const { PlayerID } = getMainUserState(state);
                    const mySeat = getPlayerSeatNo(
                        state,
                        host.HostId,
                        PlayerID
                    );
                    if (!mySeat) {
                        let bets = new Array<Bet>();
                        const currentBets = getBetRoom(state, host.HostId)
                            ?.Info[0].Bet;
                        if (currentBets) bets = bets.concat(currentBets);
                        const newBets = this._command.Bet.map(
                            b =>
                                ({
                                    Type: b.Base.betType,
                                    Amount: b.Base.betAmount,
                                }) as Bet
                        );
                        bets = bets.concat(newBets);
                        const payload: BetPayload = {
                            HostId: host.HostId,
                            Seat: 0,
                            PlayerId: PlayerID,
                            Bets: bets,
                        };
                        dispatch(betRoomSliceActions.bet(payload));
                    }
                }
            });

            // dispatch(
            //     inGamePopupSliceActions.open(
            //         'system.bet_success',
            //         GameType,
            //         StateMsgType.betInfo_Success,
            //         this._command.GameID
            //     )
            // );
            batch(() => {
                dispatch(
                    inGamePopupSliceActions.updateIsOpen({
                        hostId: HostId,
                        isOpen: true,
                    })
                );
                dispatch(
                    inGamePopupSliceActions.updateDataSet({
                        hostId: HostId,
                        key: 'system.bet_success',
                        gameType: GameType,
                        stateMsgType: StateMsgType.betInfo_Success,
                        gameId: this._command.GameID,
                    })
                );
            });
        } else {
            // dispatch(gameSliceActions.onCancelPendingBet());
            if (this._specialMsg !== '') {
                const key = `system.${this._specialMsg}.${this._command.Reason}`;
                if (this._isMessageExist(key)) {
                    batch(() => {
                        dispatch(
                            inGamePopupSliceActions.updateIsOpen({
                                hostId: HostId,
                                isOpen: true,
                            })
                        );
                        dispatch(
                            inGamePopupSliceActions.updateDataSet({
                                hostId: HostId,
                                key: key,
                                gameType: GameType,
                                stateMsgType: StateMsgType.betInfo_Fail,
                                gameId: this._command.GameID,
                            })
                        );
                    });
                    return;
                }
            }
            //let errorMsg = `abc.error_code.${this._command.Reason}`;
            //if (!this._isMessageExist(errorMsg)) {
            //    errorMsg = 'abc.error_common';
            let errorMsg = 'system.bet_failed';
            switch (this._command.Reason) {
                case GameError.BelowMinBet:
                    errorMsg = 'system.bet_below_win_bet';
                    break;
                case GameError.BetTimeOut:
                    errorMsg = 'system.bet_timeout';
                    break;
                case GameError.OutOfLimitRed:
                    errorMsg = 'system.bet_out_of_limit_red';
                    break;
                case GameError.NotEnoughMoney:
                    errorMsg = 'system.not_enough_money';
                    break;
                case GameError.CannotBetOpposite:
                    errorMsg = 'system.bet_opposite';
                    break;
                case 138:
                case 139:
                case 140:
                case 141:
                case 142:
                case 150:
                    errorMsg =
                        'system.commonWalletError.' + this._command.Reason;
                    break;
            }
            // dispatch(
            //     inGamePopupSliceActions.open(
            //         errorMsg != 'system.bet_failed'
            //             ? errorMsg
            //             : [errorMsg, `(${this._command.Reason})`],
            //         GameType,
            //         StateMsgType.betInfo_Fail,
            //         this._command.GameID
            //     )
            // );
            batch(() => {
                dispatch(
                    inGamePopupSliceActions.updateIsOpen({
                        hostId: HostId,
                        isOpen: true,
                    })
                );
                dispatch(
                    inGamePopupSliceActions.updateDataSet({
                        hostId: HostId,
                        //key:
                        //    errorMsg != 'abc.error_common'
                        //        ? errorMsg
                        //        : [errorMsg, `(${this._command.Reason})`],
                        key:
                            errorMsg != 'system.bet_failed'
                                ? errorMsg
                                : [
                                      { key: errorMsg, needT: true },
                                      {
                                          key: `[ERR${this._command.Reason}]`,
                                          needT: false,
                                      },
                                  ],
                        gameType: GameType,
                        stateMsgType: StateMsgType.betInfo_Fail,
                        gameId: this._command.GameID,
                    })
                );
            });
            return;
        }
    }
}
